<template>
  <div id="nav" :class="this.$route.name != 'home' ? 'is-authorized' : ''">
    <div class="top_nav">
      <div class="top_nav__overlay">
        <i class="mdi mdi-menu active" @click="$emit('open-sidebar')"></i>
        <!-- <i class="mdi mdi-magnify active"></i> -->
        <router-link class="logo" :to="'/'">
          <img src="@/assets/img/logo.svg" @click="back" />
        </router-link>

        <CoursesMenu />

        <NavbarSearch />

        <div class="buttons-block nav_avatar">
          <router-link class="info" :to="'/profile'">
            <div
              class="avatar"
              :style="{
                backgroundImage: currentUser.image ? `url(${config.baseUrl + currentUser.image})` : ''
              }"
            ></div>
            <div class="text">
              <p class="nickname">{{ currentUser.surname }} {{ currentUser.name }}</p>
              <span class="role">{{ rolename }}</span>
            </div>
          </router-link>
          <button class="logout" @click="logout">Выход</button>
        </div>
      </div>
    </div>

    <div class="bottom_nav" v-if="this.$route.name != 'home'">
      <router-link
        v-for="(item, i) in items"
        :key="i"
        :to="userRole === 'leader' && item.path === '/branches' ? item.path + '/' + currentUser.branch.id : item.path"
      >
        <div v-if="item.path === '/my-notifications' && notificationsList.length > 0" class="bottom_nav__badge">
          {{ notificationsList.length }}
        </div>
        <i :class="item.icon"></i>
        {{ item.label }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { routes } from '@/data/routes'
import CoursesMenu from '@/components/navbar/CoursesMenu'
import NavbarSearch from '@/components/navbar/NavbarSearch'
import { config } from '@/config'

export default {
  components: {
    CoursesMenu,
    NavbarSearch
  },
  methods: {
    back() {
      if (this.$route.name === 'home') {
        return
      }
      this.$router.push('/')
    },
    openAccount() {
      this.$router.push('/profile')
    },
    logout() {
      this.$store.commit('toggleAuth', false)
      this.back()
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (!this.$browserDetect.isIE) {
            window.Echo.leave(`App.User.${this.currentUser.id}`)
          }
          localStorage.removeItem('user-token')
          delete this.$axios.defaults.headers.common['Authorization']
          delete this.$axios2.defaults.headers.common['Authorization']
          this.$store.commit('AUTH_LOGOUT')
        })
      })
    }
  },
  computed: {
    config() {
      return config
    },
    notificationsList() {
      return this.$store.state.notifications.unreadNotificationsList
    },
    items() {
      return routes[this.$store.state.auth.role]
    },
    rolename() {
      return this.$store.state.auth.rolename
    },
    currentUser() {
      return this.$store.state.auth.currentUser
    },
    userRole() {
      return this.$store.state.auth.role[0]
    }
  }
}
</script>
